import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import CustomizedSnackbars from "../../components/alert/Alert";
import api from "../../services/api";
import perto2 from "../../images/perto2.png";

import {
  AppBar,
  Box,
  createTheme,
  Dialog,
  Grid,
  styled,
  ThemeProvider,
  Toolbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

let text = "";
let tipo = "";
let email = "";

export default function RedefinirSenha({ location, validarSessao }) {
  const [alerta, setAlerta] = useState(false);
  const [open, setOpen] = useState(false);
  const [CPF, setCPF] = useState("");
  const history = useHistory();

  const redefinir = (e) => {
    e.preventDefault();
    api
      .post("usuarios/solicitarRedefinicaoSenha", {
        CPF,
        naoEnviarEmail: false,
      })
      .then((res) => {
        email = res.email;
        setOpen(true);
        return;
      })
      .catch(() => {
        text =
          "Não foi possível comunicar-se com o servidor. Verifique sua conexão";
        tipo = "error";
        alertMsg();
      });
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Grid
        container
        height={window.innerHeight}
        style={{ background: "#3d79bd" }}
      >
        <Grid container direction="row" justifyContent="center">
          <Grid
            item
            xs={12}
            style={{
              paddingLeft: 15,
            }}
          >
            <h4
              style={{
                textDecoration: "none",
                color: "white",
                fontSize: "1.5rem",
              }}
            >
              <ArrowBackIcon
                onClick={() => history.push("login")}
                style={{
                  fontWeight: "bolder",
                  color: "white",
                  marginRight: 20,
                  cursor: "pointer",
                }}
              />
              Redefinir senha
            </h4>
          </Grid>
          <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
            <img src={perto2} width={"60%"} alt="" />
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{
              textAlign: "center",
              padding: !isMobile ? "0px 30% 0px 30%" : 10,
            }}
          >
            <form onSubmit={redefinir} style={{ width: "100%" }}>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    // marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="CPF"
                  label="CPF"
                  variant="filled"
                  type="number"
                  pattern="[0-9]+"
                  onChange={(event) => setCPF(event.target.value)}
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: "center" }}>
                <ThemeProvider theme={theme}>
                  <Button
                    fullWidth
                    style={{
                      color: "white",
                      marginTop: "10px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                      width: "50%",
                      fontFamily: "Gilroy-ExtraBold",
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Confirmar
                  </Button>
                </ThemeProvider>
              </Grid>
            </form>
          </Grid>
          {alerta && (
            <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
          )}
        </Grid>
      </Grid>

      <Dialog onClose={handleClose} open={open}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static" style={{ background: "#6a7277" }}>
            <Toolbar style={{ display: "flex", justifyContent: "end" }}>
              <Button color="inherit" onClick={() => setOpen(false)}>
                X
              </Button>
            </Toolbar>
          </AppBar>

          <Grid
            style={{ textAlign: "center", padding: "40px", color: "#6a7277" }}
          >
            <h2>
              Um email foi enviado para {email} com as instruções para redefinir
              sua senha
            </h2>
          </Grid>
        </Box>
      </Dialog>
    </Box>

    // <Container>
    //   <Box1>
    //     <BoxForm
    //       style={{
    //         width: isMobile ? '100%' : '450px',
    //       }}
    //     >
    //       <Form onSubmit={redefinir}>
    //         <BoxImg>
    //           <img src={logo} alt="logo" />
    //           <h4>Redefinir senha</h4>
    //         </BoxImg>
    //         <Stack spacing={1} sx={{ width: '100%' }}>
    //           {msgAlerta &&
    //             <div style={{padding: 5, backgroundColor: 'orange'}}>
    //               <h5>{msgAlerta}</h5>
    //             </div>
    //           }

    //           <TextField
    //             style={{
    //               margin: '30px',
    //               background: '#FFFF',
    //               // WebkitAppearance: 'none',
    //             }}
    //             id="CPF"
    //             label="CPF"
    //             variant="filled"
    //             type="number"
    //             pattern="[0-9]+"
    //             onChange={(event) => setCPF(event.target.value)}
    //           />

    //           <ThemeProvider theme={theme}>
    //           <Button
    //               style={{ margin: '20px', color: 'white', fontWeight:'bold' }}
    //               type="submit"
    //               variant="contained"
    //             >
    //               Confirmar
    //             </Button>
    //             </ThemeProvider>

    //             <ThemeProvider theme={secondary}>

    //             <Button
    //               style={{ margin: '20px', color: 'white', fontWeight:'bold' }}
    //               variant="contained"
    //               target="_blank"
    //               onClick={()=> history.push('/login')}
    //             >
    //              Voltar
    //             </Button>

    //             </ThemeProvider>

    //         </Stack>
    //         {alerta && (
    //           <CustomizedSnackbars
    //             texto={text}
    //             tipo={tipo}
    //           ></CustomizedSnackbars>
    //         )}
    //       </Form>
    //     </BoxForm>
    //   </Box1>
    // </Container>
  );
}

const FormTextField = styled((props) => (
  <TextField
    InputProps={{
      style: {
        fontWeight: "bolder",
      },
      disableUnderline: true,
    }}
    InputLabelProps={{
      style: { color: "black", fontFamily: "Gilroy-ExtraBold" },
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    borderRadius: 10,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: "#F5B01B",
    },
  },
});
